import styled, { css } from 'styled-components';
import { Wrapper as FloatButtonStyle } from 'components/FloatPlaidButton/style';
import { Form } from 'components/Form/styles';
import { Wrapper as FormButton } from 'components/Button/style';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.colors.purple10};
    min-height: 100%;

    ${Form} {
      gap: 16px;
    }

    ${FormButton} {
      img {
        margin-left: 8px;
      }
    }

    ${FloatButtonStyle} {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 9;

      img {
        margin-left: 8px;
      }
    }

    @media (max-width: 576px) {
      min-height: 100%;
    }
  `}
`;

export const Main = styled.main``;

export const WhiteSection = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.colors.globalWhite100};
  `}
`;

export const TitleSection = styled.div`
  margin: 16px 0 32px 0;
`;

export const UserTitle = styled.h1`
  ${({ theme }) => css`
    font-size: 3.6rem;
    font-weight: 700;
    color: ${theme.colors.neutralDark100};
    line-height: 48px;
    margin-bottom: 16px;
    display: flex;

    > span {
      font-size: 2.4rem;
      margin-left: 8px;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: 1.8rem;
    color: ${theme.colors.neutralDark80};
    line-height: 36px;
    margin-bottom: 0;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-weight: 700;
    font-size: 2.4rem;
    color: ${theme.colors.neutralDark100};
    margin-bottom: 0;
  `}
`;

export const Text = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark90};
    font-size: 1.6rem;
    line-height: 24px;
    margin-bottom: 0;

    > a {
      text-decoration: underline;
      color: ${theme.colors.purple100};
    }
  `}
`;

export const SubTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark80};
    font-weight: 700;
    font-size: 1.8rem;
  `}
`;
